import { CHAT_URL } from 'views/Main'
import CnezipIcon from '../assets/images/main/bookmark_cnezip.svg'
import HangeulIcon from '../assets/images/main/bookmark_hangeul.svg'
// import TrainingRegisterIcon from '../assets/images/main/bookmark_training_register.svg'
import HelpIcon from '../assets/images/main/bookmark_help.svg'
import TransferIcon from '../assets/images/main/bookmark_transfer.svg'
import CommunicationVisual from '../assets/images/main/visual1.svg'
import ClassVisual from '../assets/images/main/visual2.svg'
import FutureVisual from '../assets/images/main/visual3.svg'

export const bookmarkList = [
  {
    id: 1,
    title: '마주온이란',
    logo: require('../assets/images/main/bookmark1.png'),
    link: '/intro',
    target: '_blank',
  },
  {
    id: 2,
    title: '한글다듬이',
    logo: HangeulIcon,
    link: 'https://curricenterhscne.github.io/correct_bodo/',
    target: '_blank',
  },
  {
    id: 3,
    title: '초등교무학사실무',
    logo: CnezipIcon,
    link: 'https://standupjihoon.github.io/CNEZip/',
    target: '_blank',
  },
  {
    id: 4,
    title: '전입학 안내',
    logo: TransferIcon,
    link: 'https://curricenterhscne.github.io/transfer_cne/',
    target: '_blank',
  },
  // Previous training-registration bookmark retained for rollback.
  // {
  //   id: 13,
  //   title: '연수등록부',
  //   logo: TrainingRegisterIcon,
  //   link: 'https://cnesign.kr',
  //   target: '_blank',
  // },
  {
    id: 5,
    title: '들락날락',
    logo: require('../assets/images/main/bookmark5.png'),
    link: 'https://www.들락날락.net',
    target: '_blank',
  },
  {
    id: 6,
    title: '어울림톡',
    logo: require('../assets/images/main/bookmark6.png'),
    link: 'https://talkcne.or.kr',
    target: '_blank',
  },
  {
    id: 7,
    title: '문자알리미',
    logo: require('../assets/images/main/bookmark7.png'),
    link: 'https://send.cne.go.kr',
    target: '_blank',
  },
  {
    id: 8,
    title: '가상누리터',
    logo: require('../assets/images/main/bookmark8.png'),
    link: 'https://zep.us/play/DwM942',
    target: '_blank',
    //   popUp: gasangOpen && <Gasang setModalOpen={setGasangOpen} />,
    //   popUpOpen: openGasang,
  },
  {
    id: 9,
    title: '초록발자국',
    logo: require('../assets/images/main/bookmark_greenfootprint.png'),
    link: '',
    target: '',
    //   popUp: greenFootPrintOpen && <GreenFootPrint setModalOpen={setGreenFootPrintOpen} />,
    //   popUpOpen: openGreenFootPrint,
  },
  {
    id: 10,
    title: '마주온 협업',
    logo: require('../assets/images/main/bookmark11.png'),
    link: 'https://accounts.hancom.com/oauth2/authorize?client_id=5xusimMCZbLJQIfLl06i&redirect_uri=https%3A%2F%2Fwww.hancomdocs.com%2Flogin&response_type=code&scope=hancomOauth%3Awrite+hancomOauth%3Aread&state=eyJ0IjoiMTcwMjUwOTk3OTE0MSIsInJlZGlyZWN0IjoiL2tvL2hvbWUifQ%3D%3D&token=true&force_oauth=nworks',
    target: '_blank',
  },
  {
    id: 11,
    title: '마주온사용법',
    logo: require('../assets/images/main/bookmark9.png'),
    link: 'https://class.whalespace.io/cne-on-qna/lectures/345062',
    target: '_blank',
  },
  {
    id: 14,
    title: '장애해결',
    logo: HelpIcon,
    link: '/help',
    target: '_blank',
  },
  {
    id: 12,
    title: '마주온 톡톡',
    logo: '',
    link: CHAT_URL,
    target: '_blank',
  },
]

export const talkList = [
  {
    title: '소통톡',
    background: CommunicationVisual,
    bgColor: '#004998',
    hoverColor: 'rgba(0, 73, 152, .9)',
    content: [
      {
        logo: 'ico-sprite ico-sprite1-1',
        name: '충남톡(실시간 소통 서비스)',
        link: 'https://talk.worksmobile.com',
      },
      {
        logo: 'ico-sprite ico-sprite1-2',
        name: '일정관리',
        link: 'https://calendar.worksmobile.com',
      },
      {
        logo: 'ico-sprite ico-sprite1-3',
        name: '충남온자료실',
        link: 'https://drive.worksmobile.com',
      },
      {
        logo: 'ico-sprite ico-sprite1-4',
        name: '충남온메일',
        link: 'https://mail.worksmobile.com',
      },
      {
        logo: 'ico-sprite ico-sprite1-5',
        name: '충남온설문',
        link: 'https://form.worksmobile.com/forms/received',
      },
      {
        logo: 'ico-sprite ico-sprite1-6',
        name: '유레카설문',
        link: 'http://www.statschool.net/commonstat.do?method=memid_autologin&usr_id=edus',
      },
      {
        logo: 'logo-sprite logo-sprite1',
        name: '클로바노트',
        link: 'https://clovanote.naver.com',
      },
    ],
  },
  {
    title: '수업톡',
    background: ClassVisual,
    bgColor: '#0f2e4f',
    hoverColor: 'rgba(15, 46, 79, .9)',
    content: [
      {
        logo: 'ico-sprite ico-sprite2-2',
        name: '충남온배움터',
        link: 'https://class.whalespace.io',
      },
      {
        logo: 'ico-sprite ico-sprite2-3',
        name: `창의적체험
활동자료`,
        link: 'https://class.whalespace.io/cne-non-subject',
      },
      {
        logo: 'ico-sprite ico-sprite2-4',
        name: '계기교육자료',
        link: 'https://class.whalespace.io/gegi-cne',
      },
      {
        logo: 'ico-sprite ico-sprite2-5',
        name: '교수학습자료',
        link: 'https://class.whalespace.io/learningmaterials',
      },
      {
        logo: 'logo-sprite logo-sprite4',
        name: '퀴즈앤',
        link: 'https://www.quizn.show/usr/login/loginForm.do',
      },
      {
        logo: 'ico-sprite ico-sprite-aigle',
        name: '아이글(AiGLE)\nAI서논술평가',
        link: 'https://aigle.neolab.net',
      },
      {
        logo: 'logo-sprite logo-sprite2',
        name: '미리캔버스',
        link: 'https://api.miricanvas.com/api/v2/auth/whale/oauth20?ssoOrigin=ai.cne.go.kr',
      },
      {
        logo: 'logo-sprite logo-sprite3',
        name: '클로바 더빙',
        link: 'https://clovadubbing.naver.com',
      },
    ],
  },
  {
    title: '미래톡',
    background: FutureVisual,
    bgColor: '#f29f00',
    hoverColor: 'rgba(242, 159, 0, .9)',
    content: [
      {
        logo: 'ico-sprite ico-sprite3-1',
        name: `인공지능(AI)
교육`,
        link: 'https://class.whalespace.io/ai-class',
      },
      {
        logo: 'ico-sprite ico-sprite3-2',
        name: `소프트웨어
(SW)교육`,
        link: 'https://class.whalespace.io/cnesw',
      },
      {
        logo: 'ico-sprite ico-sprite3-3',
        name: '생태환경교육',
        link: 'https://class.whalespace.io/cne-environment',
      },
      { logo: 'ico-sprite ico-sprite3-4', name: '상상이룸교육', link: 'https://sang.cne.go.kr' },
      {
        logo: 'ico-sprite ico-sprite3-7',
        name: `미래형
과학교육`,
        link: 'https://class.whalespace.io/scienceeducation',
      },
      {
        logo: 'ico-sprite ico-sprite3-5',
        name: `디지털
소양교육`,
        link: 'https://class.whalespace.io/cne-media-literacy',
      },
      {
        logo: 'ico-sprite ico-sprite3-6',
        name: `정보화기기
사용법`,
        link: 'https://class.whalespace.io/cne-it',
      },
      {
        logo: 'ico-sprite ico-sprite3-8',
        name: `충남
전자등록부`,
        link: 'https://qr.bubblecon.io/qr',
      },
    ],
  },
]
